// src/store/slices/userProfileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StopsProfileSlice {
    selectedView: string;
}

const initialState: StopsProfileSlice = {
    selectedView: 'info',
};

const stopsProfileSlice = createSlice({
    name: 'stopsProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = stopsProfileSlice.actions;
export default stopsProfileSlice.reducer;